import React from "react";
import { FormattedMessage } from "react-intl";
import makeCommandDispatcherWithMessageFeedback from "web/core/apollo/makeCommandDispatcherWithMessageFeedback";
import { areAllOptionsSet } from "./areAllOptionsSet";
import createAddToCartMutationDefinition from "./createAddToCartMutationDefinition";

const EnhanceAddToCart = ({ addToCartCallback, AddToCartMutation }) =>
  makeCommandDispatcherWithMessageFeedback(
    {
      addToCart:
        (props) =>
        ({ qty }) => {
          const customOptions =
            props.product.custom_options ?? props.product.customOptions;

          const optionsAreSet = (props) => {
            const allOptionsAreSet = areAllOptionsSet(
              props.product,
              props.selectedOptions,
              props.selectedCustomOptions,
              props.selectedBundleOptions
            );

            if (!allOptionsAreSet) {
              return (
                <FormattedMessage
                  id="modules.AddToCart.errorMissingOptions"
                  defaultMessage="Please select your product options"
                />
              );
            }
            if (!qty || !(qty > 0)) {
              return (
                <FormattedMessage
                  id="modules.AddToCart.errorMissingQty"
                  defaultMessage="Please select a valid quantity"
                />
              );
            }

            return false;
          };

          const variables = {
            sku: props.product.sku,
            options: [],
            custom_options: [],
            qty,
          };

          if (customOptions) {
            variables.custom_options = customOptions
              .filter((option) => props.selectedCustomOptions[option.option_id])
              .map((option) => ({
                option_id: Number(option.option_id),
                option_value: props.selectedCustomOptions[option.option_id],
              }));
          }

          if (props.product.options) {
            variables.options = props.product.options.map((option) => ({
              option_id: Number(option.id),
              option_value: props.selectedOptions[option.id],
            }));
          }

          if (props.product.bundleOptions) {
            variables.bundle_options = props.product.bundleOptions
              .filter((option) => {
                const selectedOption = props.selectedBundleOptions[option.id];
                return selectedOption && selectedOption.values;
              })
              .map((option) => ({
                option_id: Number(option.id),
                option_values: props.selectedBundleOptions[option.id].values,
                quantity: props.selectedBundleOptions[option.id].quantity,
              }));
          }

          return createAddToCartMutationDefinition({
            props,
            AddToCartMutation,
            variables,
            optionsAreSet,
            addToCartCallback,
          });
        },
    },
    false
  );

export default EnhanceAddToCart;
